var React = require('react');

function Check12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Inverted=off, Size=12x12"},React.createElement("path",{"id":"Vector 199","d":"M2 5.13L5.667 10 10 2","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Check12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Check12x12;

Check12x12.default = Check12x12;
